<template>
  <div>
    <p>Loading...</p>
  </div>
</template>

<script>
export default {
  methods: {
    handleLoginEvent (data) {
      this.$router.push(data.state.target || '/')
    }
  },
  created () {
    console.log('*****************CALLBACK PAGE CALLED *******************')
    this.$auth.handleRedirectCallback()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Callback.vue